import "./WhatsAppChatDemo.css";

/**
 * Auto-looping WhatsApp conversation demo for the landing page.
 * Pure CSS animation — no JS timers, no video. Loops every ~28s.
 *
 * Each child of .wa-demo-feed gets an animation-delay defined in CSS.
 * Order matters: child :nth-child() selectors target each message.
 */
export default function WhatsAppChatDemo() {
  return (
    <div className="wa-demo-wrap" data-testid="wa-chat-demo">
      <div className="wa-demo-screen">
        <div className="wa-demo-header">
          <div className="av">K</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 14, fontWeight: 600 }}>Kobolog AI</div>
            <div style={{ fontSize: 11, opacity: 0.7 }}>online · always-on bookkeeping</div>
          </div>
          <div style={{ fontSize: 18, opacity: 0.7 }}>📞</div>
        </div>

        <div className="wa-demo-feed">
          {/* 1. Trader sale */}
          <div className="wa-bubble me">
            I sold 3 bags of rice ₦45,000<div className="meta">12:14 ✓✓</div>
          </div>
          {/* 2. Trader voice cue */}
          <div className="wa-bubble me" style={{ display: "inline-flex", gap: 8, alignItems: "center" }}>
            🎙️ <span style={{ width: 80, height: 4, background: "rgba(0,0,0,0.15)", borderRadius: 2, position: "relative" }}>
              <span style={{ position: "absolute", left: 0, top: 0, height: "100%", width: "60%", background: "#4FAE4F", borderRadius: 2 }} />
            </span> 0:08
            <div className="meta">12:14 ✓✓</div>
          </div>
          {/* 3. typing */}
          <div className="wa-typing"><span /><span /><span /></div>
          {/* 4. Bot reply */}
          <div className="wa-bubble them">
            ✅ Logged ₦45,000 sale · 3 bags rice<br/>
            <strong>Today so far:</strong> ₦87,500 across 5 sales<br/>
            <strong>Stock:</strong> rice 9 bags left
            <div className="meta">12:14</div>
          </div>
          {/* 5. Trader debt question */}
          <div className="wa-bubble me">
            Who owes me?<div className="meta">12:18 ✓✓</div>
          </div>
          {/* 6. typing */}
          <div className="wa-typing"><span /><span /><span /></div>
          {/* 7. Bot debtors */}
          <div className="wa-bubble them">
            💸 <strong>4 customers owe ₦68,000</strong><br/>
            · Ibrahim · ₦15,000 (Fri)<br/>
            · Mama Tunde · ₦8,000 (next wk)<br/>
            · Mr Audu · ₦25,000<br/>
            · Aisha · ₦20,000
            <div className="meta">12:18</div>
          </div>
          {/* 8. Trader loan */}
          <div className="wa-bubble me">
            Can I get a loan?<div className="meta">12:31 ✓✓</div>
          </div>
          {/* 9. typing */}
          <div className="wa-typing"><span /><span /><span /></div>
          {/* 10. Bot offer */}
          <div className="wa-bubble them">
            💰 <strong>You&apos;re eligible for ₦120,000</strong><br/>
            15% interest · 30 days · ₦4,600/day<br/>
            Tap to accept &nbsp;👇
            <div className="meta">12:31</div>
          </div>
          {/* 11. Receipt confirmation */}
          <div className="wa-bubble them" style={{ background: "#FFF9E6", border: "1px solid #F0E2A8" }}>
            🎉 <strong>₦120,000 disbursed</strong> to your bank<br/>
            <span style={{ fontSize: 11, opacity: 0.7 }}>GTBank ****4582 · ref KBL-2A9F1</span>
            <div className="meta">12:32</div>
          </div>
        </div>

        <div className="wa-input-bar">
          <div className="pill">😊 &nbsp; Type a message...</div>
          <div className="mic">🎙️</div>
        </div>
      </div>
    </div>
  );
}
